export default "__VITE_ASSET__wMbN7KxO__"